export const phoneValidation = /^(\+[1-9]\d{10})$/
export const zipCodeValidation = /^\d{5}$/
export const trainerPhoneValidation =
  /^(\+[1-9](\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})|(^$)$/
export const emailWithDomainValidation = '[a-z0-9]+@campgladiator.com'
export const imageMimeType = /image\/(png|jpg|jpeg)/i
